/** Labels for Luxury and Local-shops section variants (reuse designers / boutiques APIs). */

export const SECTION_BRANDS = {
  default: {
    featuredStripKey: 'browse.handPickedByFlea',
    featuredScope: 'designer_items',
    newShop: '✨ New Shop',
    createShop: '🏪 Create Shop',
    myShop: '🏪 My Shop',
  },
  luxury: {
    featuredStripKey: 'browse.handPickedByFlea',
    featuredScope: 'designer_items',
    newShop: '✨ New Brand',
    createShop: '🏪 Create Luxury Shop',
    myShop: '🏪 My Luxury Shop',
  },
  'local-shops': {
    pageDescription:
      'Discover Unique items from local sellers and shops across Egypt on Flea and browse neighborhood listings and trusted local businesses.',
    featuredStripKey: 'browse.handPickedByFlea',
    featuredScope: 'local_store_items',
    newShop: '✨ New Local Shop',
    createShop: '🏪 Create Local Shop',
    myShop: '🏪 My Local Shop',
  },
  boutiques: {
    featuredStripKey: 'browse.handPickedByFlea',
    featuredScope: 'boutique_items',
    newShop: '✨ New Boutique',
    createShop: '🏪 Create Boutique',
    myShop: '🏪 My Boutique',
  },
  artists: {
    pageDescription:
      'Discover unique artwork and creative pieces from talented artists across Egypt on Flea.',
    featuredStripKey: 'browse.handPickedByFlea',
    featuredScope: 'artist_items',
    newShop: '🎨 New Artist',
    createShop: '🎨 Create Artist Shop',
    myShop: '🎨 My Artist Shop',
  },
};

export function getSectionBrand(brandKey, fallback = 'default') {
  return SECTION_BRANDS[brandKey] || SECTION_BRANDS[fallback];
}
